export default {
  //默认本机调试
  'localhost':{
    isToken:false,       //是否包含token
    cnzz:undefined,      //cnzz 统计地址
    lang:'zh',           //默认语言 cn en
    color:'26a2ff',      //ui的默认颜色
    imageList:{name:'library_group'}, //拉花图库路由对象  false,就是没有
  },
  //国内官方
  'cn':{
    isToken:true,
    cnzz:undefined,
    lang:'zh',
    color:'26a2ff',
    imageList:{name:'library_group'},
  },
  //国内定制cst
  'cn_cst':{
    isToken:false,
    cnzz:undefined,
    lang:'zh',
    color:'5f4120',
    imageList:false,
  },
  //海外生产
  'cc':{
    isToken:false,
    cnzz:undefined,
    lang:'en',
    color:'26a2ff',
    imageList:{name:'library_group'},
  },
  //意大利奇诺
  'italy_cino':{
    isToken:false,
    cnzz:undefined,
    lang:'en',
    color:'5f4120',
    imageList:{name:'library_group'},
  },
  //华硕国内
  'cn_asus':{
    isToken:false,
    cnzz:undefined,
    lang:'zh',
    color:'26a2ff',
    imageList:{name:'library_join_rand',query:{join_id:5}},
  },
  //
  'coffeecolorato':{
    isToken:false,
    cnzz:undefined,
    lang:'en',
    color:'cc352a',
    imageList:{name:'library_group'},
  }
}




// WEBPACK FOOTER //
// ./src/store/config.js